<template>
<div class="form_wrapper user_login_form_wrapper">
    <div class="section_title">
        <h1 v-if="form_id == 'login'">Login</h1>
        <h1 v-else-if="form_id == 'forgot_password'">Forgot Password</h1>
        <h1 v-else>Reset Password</h1>
    </div>
    <display-message :option="login_message"></display-message>
    <div class="section_content">
        <div v-if="form_id == 'login' && current_user && !redirect_to">
            <p><strong>Currently logging as: {{ current_user.name }}</strong></p>
            <p>Please choose a panel to log in to</p>
            <div class="user_login_panel_selector_container">
                <a class="btn btn-primary" v-bind:href="next_link.link" v-for="(next_link,next_key) in next_available">Login into {{ next_link.name }}</a>
            </div>
            <div class="user_login_panel_display_form_container" v-show="!display_login_form">
                <a class="btn btn-primary button_display_login_form" href="javascript:void(0)" v-on:click="display_login_form = !display_login_form">{{ display_login_form?'Hide login form':'Login again as a different user' }}</a>
            </div>
        </div>
        <p v-else-if="form_id == 'forgot_password'">Please enter your email or username below, a reset password link will be sent to your email. <a  @click="form_id = 'login'" href="javascript:void(0);">login</a> to your account</p>
        <p v-else-if="form_id == 'forgot_password_submitted'">
            <strong>Password reset</strong><br><br>
            Thank you <strong><i>{{ username }}</i></strong><br><br>
            An email has been sent to the registered email address for this account with instructions on how to reset your password.<br>
            Please check your email inbox for this email. If it does not appear soon, check your spam or junk folders.<br><br>
            Once your password has been reset, please <a  @click="form_id = 'login'" href="javascript:void(0);">login</a> to your account
        </p>
        <p v-else-if="form_id == 'reset_password'">Set your new password below and login to your account</p>
        <p v-else-if="redirect_to">Loading ...</p>
        <p v-else>Login to your Macquarie Group Services account to order.</p>
        <p v-if="form_id == 'login' && !current_user">Don't have an account? <a href="/register">Click here</a> to register.</p>
        <div class="form_container user_login_form_container" v-show="display_login_form && form_id !== 'forgot_password_submitted'">
            <h2 v-if="current_user">Login as different user</h2>
            <form @submit.prevent="formSubmit">
                <input type="hidden" name="form_id" v-model="form_id">
                <div class="form_row" v-show="form_id == 'login' || form_id == 'forgot_password'">
                    <label for="login_username">Username or Email: </label>
                    <input type="text" id="login_username" name="username" v-model="username">
                </div>
                <div class="form_row" v-show="form_id == 'login' || form_id == 'reset_password'">
                    <label for="login_password">Password: </label>
                    <input type="password" id="login_password" name="password" v-model="password">
                </div>
                <div class="form_row" v-show="form_id == 'reset_password'">
                    <label for="login_password_repeat">Repeat Password: </label>
                    <input type="password" id="login_password_repeat" name="password_repeat" v-model="password_repeat">
                </div>
                <div class="form_row form_row_checkbox_container" v-show="form_id == 'login' && !current_user">
                    <a class="forgot_password_link" href="javascript:void(0)" @click="form_id = 'forgot_password'">Forgot your password?</a>
                    <label for="login_remember">Remember Me</label>
                    <input type="checkbox" id="login_remember" name="remember" v-model="remember">
                </div>
                <div class="form_row form_row_forgot_password" v-show="form_id == 'forgot_password'">
                    <a class="forgot_password_link" href="javascript:void(0)" @click="form_id = 'login'">Back to login</a>
                </div>
                <div class="form_row form_row_controller">
                    <input class="btn btn-primary" type="submit" value="Login" v-show="form_id == 'login'">
                    <input class="btn btn-primary" type="submit" value="Send Email" v-show="form_id == 'forgot_password'">
                    <input class="btn btn-primary" type="submit" value="Update Password" v-show="form_id == 'reset_password'">
                </div>
            </form>
        </div>
    </div>


</div>
</template>

<script>
    export default {
        name: 'LoginForm',
        props: ['option'],
        data() {
            let option = this.option;
            if (typeof option === 'string') {
                option = JSON.parse(window.atob(option));
            }
            // Branch the auto-hide on message_type: info / success can
            // disappear after 5s because the user doesn't need to read
            // them carefully, but warning / error messages explain WHY
            // the user was redirected here (e.g. "Permission denied: you
            // do not have agent permission") and need to stay visible
            // until dismissed. 0 = persist indefinitely in DisplayMessage.
            let initial_message_type = option.message_type ? option.message_type : '';
            let data_set = {
                login_message: {
                    message_type: initial_message_type,       // ''-default blue text;'success'-green text;'warning'-orange text,'error'-red text;
                    message: option.message?option.message:'',
                    extra_class: ['container'],
                    time_out: (initial_message_type === 'warning' || initial_message_type === 'error') ? 0 : 5000
                },
                next_available: option.next_available?option.next_available:{},
                redirect_to: '',
                display_login_form: option.current_user?false:true,
                current_user: option.current_user?option.current_user:null,
                message_type: option.message_type?option.message_type:'',       // ''-default blue text;'success'-green text;'warning'-orange text,'error'-red text;
                message: option.message?option.message:'',
                form_id: option.form_id?option.form_id:'login',
                username: option.username?option.username:'',
                password: '',
                password_repeat: '',
                remember: option.remember?true:false
            };

            return data_set;
        },
        methods: {
            formSubmit(e) {
                e.preventDefault();
                let current_object = this;
                let error_message = [];
                let username_el = document.getElementById('login_username');
                let password_el = document.getElementById('login_password');
                if (username_el && username_el.value && !current_object.username) {
                    current_object.username = username_el.value;
                }
                if (password_el && password_el.value && !current_object.password) {
                    current_object.password = password_el.value;
                }
                // JS submission value validation
                // if (!current_object.username) {
                //     error_message.push('Username is required')
                // }
                // if ((current_object.form_id === 'login' || current_object.form_id === 'reset_password') && !current_object.password) {
                //     error_message.push('Password is required')
                // }


                let post_data = {};
                switch (current_object.form_id) {
                    case 'forgot_password':
                        if (!current_object.username) {
                            error_message.push('Username is required')
                        }
                        post_data.username = current_object.username;
                        break;
                    case 'login':
                        if (!current_object.username) {
                            error_message.push('Username is required')
                        }
                        post_data.username = current_object.username;
                        if (!current_object.password) {
                            error_message.push('Password is required')
                        }
                        post_data.password = current_object.password;
                        post_data.remember = current_object.remember;
                        break;
                    case 'reset_password':
                        if (!current_object.password) {
                            error_message.push('Password is required')
                        }
                        post_data.password = current_object.password;
                        if (current_object.password_repeat != current_object.password) {
                            error_message.push('Repeat Password is not the same as Password')
                        }
                        break;
                }
                if (error_message.length > 0) {
                    current_object.login_message.message_type = 'error';
                    current_object.login_message.message = error_message;
                    return false;
                }

                axios.post('/login', {
                    render_type: 'json',
                    form_id: current_object.form_id,
                    post_data: post_data
                })
                    .then(function (response) {
// console.log('allen debug axios login',response);
                        current_object.output = response.data;
                        if (response.data) {
                            if (response.data.status) {
                                switch (response.data.status) {
                                    case 'OK':
                                        current_object.login_message.message_type = 'success';
                                        if (current_object.form_id == 'forgot_password') {
                                            current_object.form_id = 'forgot_password_submitted';
                                        }
                                        break;
                                    case 'PERMISSION_DENIED':
                                        current_object.login_message.message_type = 'warning';
                                        break;
                                    default:
                                        current_object.login_message.message_type = 'error';
                                }
                                if (response.data.message) {
                                    current_object.login_message.message = response.data.message;
                                    if (current_object.login_message.message_type === 'success') {
                                        // hide message on successful login - required by MM
                                        current_object.login_message.message = '';
                                    }
                                }
                                if (response.data.user) {
                                    current_object.$root.current_user = response.data.user;
                                    if (!current_object.$root.current_id) {
                                        current_object.$root.current_id = {};
                                    }
                                    current_object.$root.current_id.operator = response.data.user.id;
                                    current_object.$root.current_id.user = response.data.user.id;

                                    current_object.current_user = response.data.user;
                                    current_object.display_login_form = false;
                                }
                                if (response.data.next_available) {
                                    current_object.next_available = response.data.next_available;
                                }
                                if (response.data.redirect_to) {
                                    current_object.redirect_to = response.data.redirect_to;
                                    setTimeout(function () {
                                        window.location.href = response.data.redirect_to;
                                    }, 1);
                                }
                            } else {
                                current_object.login_message.message_type = 'error';
                                if (response.data.message) {
                                    current_object.login_message.message = response.data.message;
                                } else {
                                    current_object.login_message.message = 'System error, unable to login';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
// console.log('allen debug axios login catch error',error);
                        current_object.output = error;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
